export const INVENTORY_TASK_LIST = ['INVENTORY_TASK_LIST'];

export const INVENTORY_TASK_WAREHOUSE = ['INVENTORY_TASK_WAREHOUSE'];
